export default __webpack_public_path__ + "static/allow_location-62d9798be9e8ad995b5ac07aecdd33c2.png";